/* globals self */ "use strict";
const fetchModule = self.fetch.bind(self);
module.exports = fetchModule;
module.exports.default = module.exports;

//# sourceMappingURL=index.js.map